<template>
  <div style="background: #FAF9F5;">
    <!-- Start blog-posts Area -->
    <section class="blog-posts-area section-padding">
      <div class="schools-posts-area" >
        <div class="row">
          <div class="col-lg-3 schools-posts-area-lf" style="padding-right: 0;">
            <div class="schools-posts-area-lf-t" style="font-size: 24px; line-height: 28px">
              International Exchange and <br/>
              Cooperation Programs</div>
            <ul class="schools-posts-area-lf-m">
              <li v-for="item in blogList" @click="checkLi(item.id)" :class="[currentBlog.id===item.id?'active':'']">{{item.title}}</li>

            </ul>
            <img class="schools-posts-area-lf-b" src="http://en.sc.ruc.edu.cn/static/images/school/png10.png" />
          </div>
          <div class="col-lg-9 post-list blog-post-list">
            <div class="single-post">



              <h2 class="blog-detail-tit">
                {{ currentBlog.title }}
              </h2>


              <div class="blog-detail-img">
                <img class="img-fluid wow slideInLeft" :src="currentBlog.img" alt="">
              </div>

              <div class="blog-detail-content content-wrap  wow slideInRight">
                <p v-html="currentBlog.content">
                </p>


              </div>



            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End blog-posts Area -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      currentBlog: {},
      blogList: [
        {
          id: '7',
          title: 'International Exchange Program',
          img: 'http://en.sc.ruc.edu.cn/static/images/collaboration/detail/7.jpg',
          author: '国际学院',
          content: 'Sino-French Institute accepts short-term exchange students from three French partner universities, namely Sorbonne University, Paul-Valéry University and KEDGE Business School, and conducts full English and French specialized courses as well as different levels of Chinese courses for international students, which cover the aspects of China’s politics, economy, culture, etc. In addition, Sino-French Institute also carries out various cultural experiences, career lectures and visits for international students, so as to cultivate international students through the combination of theory and practice, and to help them better understand what they have learned in the classroom and get to know China.'
        },
        {
          id: '6',
          title: 'China-Europe European Law Program',
          img: 'http://en.sc.ruc.edu.cn/static/images/collaboration/detail/6.JPG',
          author: '国际学院',
          content: 'Renmin University of China-University of Geneva “China-Europe European Law Program” is an international cooperation and training program for innovative talents established by the China Scholarship Council (CSC). Since 2016, Suzhou Campus has been responsible for the French language training of the “China-Europe European Law Program”.\n' +
            'The program selects undergraduates who have obtained law degrees from famous law schools in China, and after interviews and selections, they will undergo French language training and specialized courses for 8 months in Suzhou Campus, and then go to the University of Geneva Law School to study for a master’s degree of “European and International Law” in the fall of the second year with the financial support of CSC. The program aims to cultivate young Chinese legal elites who are bilingual (English and French) and understand two laws (Chinese and European law), and to send talents to influential international organizations.\n'
        }
      ]
    }
  },
  created () {
    const id = this.$route.query.id
    this.currentBlog = this.getId(id)
    console.log(id, this.currentBlog)
  },
  methods: {
    getId (id) {
      return this.blogList.find(item => item.id === id)
    },
    checkLi (id) {
      this.currentBlog = this.getId(id)
    }
  }
}
</script>

<style scoped lang="scss">
.blog-detail-tit:before{
  content: ' ';
  background-image: url(http://en.sc.ruc.edu.cn/static/images/titBg.png);

}

.blog-detail-content{
  width: 90%;
  margin: 40px auto 10px auto;
  p{
    font-weight: 400;
    font-size: 17px;
    line-height: 1.6;
    color: #666666;
  }
}
</style>



// WEBPACK FOOTER //
// InternationalDetails.vue?fdaa36e4